<stb-modal
  [noPMargins]="true"
  [responsiveMode]="'normal'"
  [isShowing]="true"
  [primaryText]="''"
  [cancelText]="''"
  (cancelClick)="close()"
  [header]="
    step() === consentKeys.GROUP
      ? ('consentText.consents.enterprise.title' | fms) || ''
      : ('consentText.consents.electronicSolicitation.title' | fms) || ''
  "
>
  @switch (step()) {
    @case (consentKeys.GROUP) {
      <p>{{ "consentText.consents.enterprise.description" | fms }}</p>

      <stb-accordion class="" [rebrand]="true">
        <stb-accordion-item
          [rebrand]="true"
          [headerText]="'consentText.consents.accordion.storebrand.title' | fms"
          [trackId]="'link-consentText.consents.accordion.storebrand.title'"
        >
          <div [innerHTML]="'consentText.consents.accordion.storebrand.description' | fms | formatTextForConsent"></div>
        </stb-accordion-item>
        <stb-accordion-item
          [rebrand]="true"
          [headerText]="'consentText.consents.accordion.information.title' | fms"
          [trackId]="'link-consentText.consents.accordion.information.title'"
        >
          <div
            [innerHTML]="'consentText.consents.accordion.information.description' | fms | formatTextForConsent"
          ></div>
        </stb-accordion-item>
      </stb-accordion>
      <br />
      @if (isPrefilled()) {
        <stb-radio-buttons
          [rebrand]="true"
          [legend]="'consentText.consents.enterprise.label' | fms"
          name="groupConsentRadio"
          [horizontal]="true"
          [group]="groupRadioButtons()"
          [message]="'onboardingConsents.dataStorage.error' | fms"
          [warning]="groupConsentControl.invalid && groupConsentControl.touched"
          (valueChanged)="setControlValue(groupConsentControl, $event)"
          data-trackid="link-onboarding-dataStorage-radioButton"
        >
        </stb-radio-buttons>
      } @else {
        <stb-skeleton height="48px" width="200px" />
      }
    }
    @case (consentKeys.MARKETING) {
      <p>{{ "consentText.consents.electronicSolicitation.description" | fms }}</p>
      <stb-accordion class="" [rebrand]="true">
        <stb-accordion-item
          [rebrand]="true"
          [headerText]="'consentText.consents.accordion.storebrand.title' | fms"
          [trackId]="'link-consentText.consents.accordion.storebrand.title'"
        >
          <div [innerHTML]="'consentText.consents.accordion.storebrand.description' | fms | formatTextForConsent"></div>
        </stb-accordion-item>
        <stb-accordion-item
          [rebrand]="true"
          [headerText]="'consentText.consents.accordion.electronic.title' | fms"
          [trackId]="'link-consentText.consents.accordion.electronic.title'"
        >
          <div [innerHTML]="'consentText.consents.accordion.electronic.description' | fms | formatTextForConsent"></div>
        </stb-accordion-item>
      </stb-accordion>
      <br />
      <stb-radio-buttons
        [rebrand]="true"
        [legend]="'consentText.consents.electronicSolicitation.label' | fms"
        name="marketingElectronicConsentRadio"
        [horizontal]="true"
        [group]="marketingElectronicRadioButtons()"
        [message]="'onboardingConsents.dataStorage.error' | fms"
        [warning]="marketingElectronicConsentControl.invalid && marketingElectronicConsentControl.touched"
        (valueChanged)="setControlValue(marketingElectronicConsentControl, $event)"
        data-trackid="link-onboarding-dataStorage-radioButton"
      >
      </stb-radio-buttons>
      <br />
      <stb-radio-buttons
        [rebrand]="true"
        [legend]="'consentText.consents.socialMediaSolicitation.label' | fms"
        name="marketingSocialMediaConsentRadio"
        [horizontal]="true"
        [group]="marketingSocialMediaRadioButtons()"
        [message]="'onboardingConsents.dataStorage.error' | fms"
        [warning]="marketingSocialMediaConsentControl.invalid && marketingSocialMediaConsentControl.touched"
        (valueChanged)="setControlValue(marketingSocialMediaConsentControl, $event)"
        data-trackid="link-onboarding-dataStorage-radioButton"
      >
      </stb-radio-buttons>
    }
  }
  <div class="flex gap-04 mt-16">
    <button
      [enableSpinner]="isSubmitting()"
      [disabled]="isSubmitting()"
      [stbButton]="'primary'"
      (click)="goNext()"
      [attr.data-trackid]="'groupAndMarketingConsent.dialog.next'"
    >
      {{ steps[step()].fmsKey | fms }}
    </button>
    @if (step() === consentKeys.MARKETING) {
      <button [stbButton]="'secondary'" (click)="goBack()" [attr.data-trackid]="'groupAndMarketingConsent.dialog.back'">
        {{ "consents.button.back" | fms }}
      </button>
    }
  </div>
</stb-modal>
